import { UiRotatingItemsModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";
import { mockUiColumnModel, mockUiColumnModelContent } from "./mock-ui-column";
import { mockUiImageModel, mockUiImageModelContent } from "./mock-ui-image";
import {
    mockUiMarkdownModel,
    mockUiMarkdownModelContent
} from "./mock-ui-markdown";
import {
    mockUiSectionModel,
    mockUiSectionModelContent
} from "./mock-ui-section";
export function mockUiRotatingItemsModel({
    id = "rotating-items-1234",
    type = "uiRotatingItems",
    locale = "en",
    content = mockUiRotatingItemsModelContent()
}: Partial<UiRotatingItemsModel> = {}): UiRotatingItemsModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiRotatingItemsModelContent = UiRotatingItemsModel["content"];

export function mockUiRotatingItemsModelContent({
    title = "Ui Rotating Items",
    items = [
        mockUiSectionModel({
            id: "1",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "S500" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 1",
                                            url: "/ui-rotating-items/set-01-image@2x.png",
                                            width: 998,
                                            height: 902
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 1st section",
                                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "2",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "C300" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 2",
                                            url: "/ui-rotating-items/set-02-image@2x.png",
                                            width: 1200,
                                            height: 910
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 2nd section",
                                            "Nullam nulla est, pharetra non tempus eget, consectetur ut velit."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "3",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "WP400" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 3",
                                            url: "/ui-rotating-items/set-03-image@2x.png",
                                            width: 882,
                                            height: 886
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 3rd section",
                                            "Proin commodo nisi eget leo luctus pretium."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "4",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "S400" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 5,
                                    offset: 1,
                                    bottom: "none",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 4",
                                            url: "/ui-rotating-items/set-04-image@2x.png",
                                            width: 730,
                                            height: 1160
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "none",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 4th section",
                                            "Pellentesque molestie sit amet lectus vel sollicitudin."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "5",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "WP300" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 5",
                                            url: "/ui-rotating-items/set-05-image@2x.png",
                                            width: 992,
                                            height: 1010
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 5th section",
                                            "In malesuada gravida tortor non aliquet."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "6",
            content: mockUiSectionModelContent({
                verticalAlign: "Center",
                background: { angle: 120, gradient: "C500" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 7,
                                    bottom: "cozy",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 6",
                                            url: "/ui-rotating-items/set-06-image@2x.png",
                                            width: 1200,
                                            height: 944
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 5,
                                    bottom: "none",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 6th section",
                                            "Curabitur sagittis velit quam, ac auctor urna maximus eu."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiSectionModel({
            id: "7",
            content: mockUiSectionModelContent({
                verticalAlign: "Bottom",
                background: { angle: 120, gradient: "CP500" },
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    span: 6,
                                    bottom: "none",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            title: "Image 7",
                                            url: "/ui-rotating-items/set-07-image@2x.png",
                                            width: 1012,
                                            height: 1126
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                md: {
                                    align: "left",
                                    span: 6,
                                    bottom: "outerspace",
                                    top: "cozy"
                                }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        textSize: "Large",
                                        content: [
                                            "# 7th section",
                                            "Quisque semper enim sed metus pellentesque porttitor."
                                        ].join("\n\n")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    ]
}: Partial<UiRotatingItemsModelContent> = {}): UiRotatingItemsModelContent {
    return {
        title,
        items
    };
}
